import { Component, ElementRef, HostListener, OnDestroy, OnInit, Type, ViewChild } from '@angular/core';
import { MetodosModal } from '../../interfaces/metodos-modal.interface';
import { ModalController } from '@ionic/angular';
import { ModalRoleEnum } from '../../enums/modal-role.enum';
import { AbaGeralCadastroProdutosComponent } from './aba-geral-cadastro-produtos/aba-geral-cadastro-produtos.component';
import { AbaPizzaCadastroProdutosComponent } from './aba-pizza-cadastro-produtos/aba-pizza-cadastro-produtos.component';
import { AbaMacarraoCadastroProdutosComponent } from './aba-macarrao-cadastro-produtos/aba-macarrao-cadastro-produtos.component';
import { AbaLasanhaCadastroProdutosComponent } from './aba-lasanha-cadastro-produtos/aba-lasanha-cadastro-produtos.component';
import { AbaSorveteCadastroProdutosComponent } from './aba-sorvete-cadastro-produtos/aba-sorvete-cadastro-produtos.component';
import { FiltrarProdutosService } from 'src/app/core/services/behavior/filtrar-produtos.service';
import { CadastroPerguntasService } from 'src/app/core/services/behavior/cadastro-perguntas.service';
import { Subscription } from 'rxjs';

type AbaCadastroProdutosDialog = 'geral' | 'pizza' | 'macarrao' | 'lasanha' | 'sorvete';

@Component({
    selector: 'app-cadastro-produtos-dialog',
    templateUrl: './cadastro-produtos-dialog.component.html',
    styleUrls: ['./cadastro-produtos-dialog.component.scss']
})
export class CadastroProdutosDialogComponent implements OnInit, MetodosModal, OnDestroy {
    @ViewChild('headerRef', { read: ElementRef }) header!: ElementRef;
    @ViewChild('subHeaderRef', { read: ElementRef }) subheader!: ElementRef;
    
    public abaAtiva: AbaCadastroProdutosDialog = 'geral';
    public nomeProduto: string = null;
    public nomePergunta: string = null;
    public alturaTela: number = 0;
    public alturaLivre: number = 0;

    private subscriptions: Subscription[] = [];

    public navPills: NavPill[] = [
        {
            descricao: 'Geral',
            nomeAba: 'geral',
            componente: AbaGeralCadastroProdutosComponent
        },
        {
            descricao: 'Pizza',
            nomeAba: 'pizza',
            componente: AbaPizzaCadastroProdutosComponent
        },
        {
            descricao: 'Lasanha',
            nomeAba: 'lasanha',
            componente: AbaLasanhaCadastroProdutosComponent
        },
        {
            descricao: 'Macarrão',
            nomeAba: 'macarrao',
            componente: AbaMacarraoCadastroProdutosComponent
        },
        {
            descricao: 'Sorvete',
            nomeAba: 'sorvete',
            componente: AbaSorveteCadastroProdutosComponent
        }
    ];

    constructor(
        private modalCtrl: ModalController,
        private _filtrarProdutosService: FiltrarProdutosService,
        private cadastroPerguntasService: CadastroPerguntasService,
    ) {
        this.observarNomeProduto();
        this.observarNomePergunta();
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach((subs) => subs.unsubscribe());
    }

    public ngOnInit() {        
        this.nomeProduto = null;
        
        setTimeout(() => {
            this.getScreenSize();
        }, 500)
    }

    @HostListener('window:resize', ['$event'])
    getScreenSize() {
        this.alturaTela = window.innerHeight;

        const alturaHeader = this.header.nativeElement.offsetHeight;
        const alturaSubHeader = this.subheader.nativeElement.offsetHeight;
        const alturaOcupada = alturaHeader + alturaSubHeader;

        this.alturaLivre = this.alturaTela - alturaOcupada;
    }

    private observarNomeProduto() {
        this.subscriptions.push(this.cadastroPerguntasService.nomeProduto.subscribe((res) => this.nomeProduto = res));
    }

    private observarNomePergunta() {
        this.subscriptions.push(this.cadastroPerguntasService.nomePergunta.subscribe((res) => this.nomePergunta = res));
    }

    public get getPillAtiva() {
        return this.navPills.find(l => l.nomeAba === this.abaAtiva);
    }

    public async cancel() {
        this.nomeProduto = null;
        await this.modalCtrl.dismiss(null, ModalRoleEnum.CANCEL);
    }

    public async confirm() {
        //const dataClose = new CadastroClientesDataClose(this.cliente);
        this.nomeProduto = null;
        await this.modalCtrl.dismiss(null, ModalRoleEnum.CONFIRM);
    }

    public filtrarProdutosOnInput(value: string) {
        this._filtrarProdutosService.filtro$.next(value);
    }

    public setGuiaAtivaOnClick(abaAtiva: AbaCadastroProdutosDialog) {
        this.abaAtiva = abaAtiva;
    }
}

export class NavPill {
    constructor(
        public descricao: string,
        public nomeAba: AbaCadastroProdutosDialog,
        public componente: Type<any>
    ) { }
}
